import { FileType } from '@/api/shared.types.ts';

export const EvidenceTypes = {
  CAPTURED_MOMENT: 'capturedMoment',
  CERTIFICATE: 'certificate',
} as const;

export type EvidenceType = (typeof EvidenceTypes)[keyof typeof EvidenceTypes];

export type Evidence = {
  id: string;
  submittedAtUnix: number;
  type: EvidenceType;
  fileType: FileType;
  objectKey: string;
  fetchUrl: string;
};
